import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { environment } from '@env';

import { MessagingService } from '@shared/services/messaging.service';
import { UpdateSerive } from '@shared/services/update.service';
import { RxEvent } from '@shared/services/rx-event.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {

  public showChat = false;

  public updateAvailable = false;

  constructor(
    @Inject(DOCUMENT) public document: Document,
    public events: RxEvent,
    public updateService: UpdateSerive,
    public messagingService: MessagingService,
  ) {
    this.subscribeToUpdates();
    this.updateService.checkForUpdates();
  }

  private async subscribeToUpdates() {
    this.updateService.updated.subscribe(() => {
      // this.updateAvailable = true
    });
  }

  public subscribeToSidebarToggleEvents() {
    this.events.subscribe('sidebar::toggle', () => {
      const body = this.document.getElementsByTagName('body')[0];

      body.classList.toggle('show-sidebar');
    });
  }

  async refresh() {
    window.location.reload();
  }

  public ngOnInit() {
    this.setVariables();
    this.messagingService.receiveMessage();
  }

  private setVariables() {
    const theme = environment.theme;
    for (const key in theme) {
      // Transforma cammelCase no nome real das propriedades.
      // Exemplo: primaryColor > --primary-color
      const propertyName = '--' + key.split(/(?=[A-Z 0-9])/).join('-').toLowerCase();

      this.document.documentElement.style.setProperty(propertyName, theme[key]);
    }
    if (window.localStorage.getItem('dark-mode')) {
      this.document.getElementById('full-window').classList.add('dark-mode');
    }
  }

}
